module.exports = __webpack_public_path__ + "assets/img/ph_base_big.45343b31.svg";